// Updated helper function for badge classes with CSS
export const badgeStyles = {
  // These are kept for reference or for components still using Tailwind
  tailwind: {
    topic: {
      politics: "tw-bg-orange-100 tw-text-orange-800",
      economy: "tw-bg-blue-100 tw-text-blue-800",
      foreign_policy: "tw-bg-teal-100 tw-text-teal-800",
      law: "tw-bg-purple-100 tw-text-purple-800",
      health: "tw-bg-red-100 tw-text-red-800",
      social_issues: "tw-bg-pink-100 tw-text-pink-800",
      defense: "tw-bg-yellow-100 tw-text-yellow-800",
      others: "tw-bg-gray-100 tw-text-gray-800",
    },
    sentiment: {
      positive: "tw-bg-green-100 tw-text-green-800",
      negative: "tw-bg-red-100 tw-text-red-800",
      neutral: "tw-bg-blue-100 tw-text-blue-800",
    },
  },

  // CSS class versions
  newsCard: {
    topic: {
      politics: "news-card__badge news-card__badge--topic-politics",
      economy: "news-card__badge news-card__badge--topic-economy",
      foreign_policy: "news-card__badge news-card__badge--topic-foreign_policy",
      law: "news-card__badge news-card__badge--topic-law",
      health: "news-card__badge news-card__badge--topic-health",
      social_issues: "news-card__badge news-card__badge--topic-social_issues",
      defense: "news-card__badge news-card__badge--topic-defense",
      others: "news-card__badge news-card__badge--topic-others",
    },
    sentiment: {
      positive: "news-card__badge news-card__badge--sentiment-positive",
      negative: "news-card__badge news-card__badge--sentiment-negative",
      neutral: "news-card__badge news-card__badge--sentiment-neutral",
    },
  },

  articleModal: {
    topic: {
      politics: "article-modal__badge article-modal__badge--topic-politics",
      economy: "article-modal__badge article-modal__badge--topic-economy",
      foreign_policy:
        "article-modal__badge article-modal__badge--topic-foreign_policy",
      law: "article-modal__badge article-modal__badge--topic-law",
      health: "article-modal__badge article-modal__badge--topic-health",
      social_issues:
        "article-modal__badge article-modal__badge--topic-social_issues",
      defense: "article-modal__badge article-modal__badge--topic-defense",
      others: "article-modal__badge article-modal__badge--topic-others",
    },
    sentiment: {
      positive: "article-modal__badge article-modal__badge--sentiment-positive",
      negative: "article-modal__badge article-modal__badge--sentiment-negative",
      neutral: "article-modal__badge article-modal__badge--sentiment-neutral",
    },
  },
};

export default badgeStyles;
